import {submitFormData, submitJsonData, submitMultipartFormData} from "../../redare/utils/Request";

/**
 * Created by RdevPlugins.JsPresenterBuilderAction on 2021-11-23 10:13:03.
 */

/**
 * @param body: {key, roleId, orgId, orgName, userIds, orgParentId, orgParentName, namePinyinInitials, namePinyinShort, staffName, staffId, mobileFlag, emailFlag, mobile, email, name, id, account, key, platform, userPlatform, menuId, needResetPwd, roleIds, status, incMenu, incRole, incRoot, incPwd}
 * @param query: {curPage,pageSize}
 * @returns Promise
 */
export function findUserPage(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/user/page',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {name, mobile, email, photo, account, pwd, platform, userPlatform, menuId, roleIds, needResetPwd}
 * @param query: {}
 * @returns Promise
 */
export function addUser(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/user/add',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {accountId, account, platform, userPlatform}
 * @param query: {}
 * @returns Promise
 */
export function delUser(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/user/del',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {account, name, mobile, email, photo, where}
 * @param query: {}
 * @returns Promise
 */
export function modifyUser(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/user/modifyUser',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {accountId, platform, userPlatform, pwd, needResetPwd}
 * @param query: {}
 * @returns Promise
 */
export function modifyPwd(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/user/modifyPwd',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {key, roleId, orgId, orgName, userIds, orgParentId, orgParentName, namePinyinInitials, namePinyinShort, staffName, staffId, mobileFlag, emailFlag, mobile, email, name, id, account, key, platform, userPlatform, menuId, needResetPwd, roleIds, status, incMenu, incRole, incRoot, incPwd}
 * @param query: {}
 * @returns Promise
 */
export function findUserList(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/user/findUserList',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {accountId, roleIds, platform, userPlatform, replace}
 * @param query: {}
 * @returns Promise
 */
export function updateUserRole(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/user/role',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
* @param body: {}
* @returns Promise
*/
export function getCurrentUser(body) {

    return new Promise((resolve, reject) => {

        submitFormData({
            url: '/api/user/get/current',
            bodyParams: body
        }).then(
            result => {
                resolve(result);
        },
            error => reject(error)
        );

    });
}

/**
 * @param body: {mobile, name, orgId, id, account, userPlatform, platform, status, incMenu, incPwd}
 * @param query: {}
 * @returns Promise
 */
export function getUser(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/user/get',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
* @param body: {}
* @returns Promise
*/
export function syncSysUser(body) {

    return new Promise((resolve, reject) => {

        submitFormData({
            url: '/api/user/syncSysUser',
            bodyParams: body
        }).then(
            result => {
                resolve(result);
        },
            error => reject(error)
        );

    });
}

